import dashboardProposalTypes from "./Dashboard.types";
import { docodeHexResponse } from "../../_common/common.utils";

const INITIAL_STATE: any = {
  DasboardResponse: null,
  DasboardResponseArr: [],
  dasboardDeleteResponse: null,
  dashboardExportResponse: null,
  dashboardExportArr: null,
};

const DashboardReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case dashboardProposalTypes.DASHBOARD_PROPOSAL_START:
      return {
        ...state,
        DasboardResponse: null,
        DasboardResponseArr: [],
      };
    case dashboardProposalTypes.DASHBOARD_PROPOSAL_SUCCESS:
      return {
        ...state,
        DasboardResponse: action.payload,
        DasboardResponseArr: docodeHexResponse(
          action.payload,
          "LeadMasterListAdminKey",
        ),
      };

    case dashboardProposalTypes.DASHBOARD_PROPOSAL_FAILURE:
      return {
        ...state,
        DasboardResponse: action.payload,
        DasboardResponseArr: [],
      };

    case dashboardProposalTypes.DASHBOARD_PROPOSAL_CHANGED:
      return { ...state, DasboardResponse: null };
    case dashboardProposalTypes.DASHBOARD_PROPOSAL_DELETE_SUCCESS:
      return {
        ...state,
        dasboardDeleteResponse: action.payload,
      };

    case dashboardProposalTypes.DASHBOARD_PROPOSAL_DELETE_FAILURE:
      return {
        ...state,
        dasboardDeleteResponse: action.payload,
      };

    case dashboardProposalTypes.DASHBOARD_PROPOSAL_DELETE_CHANGED:
      return { ...state, dasboardDeleteResponse: null };

    // Export
    case dashboardProposalTypes.DASHBOARD_PROPOSAL_EXPORT_SUCCESS:
      return {
        ...state,
        dashboardExportResponse: action.payload, // Expecting a blob
        dashboardExportArr: docodeHexResponse(
          action.payload,
          "CreateRequestReportKey",
        ),
      };

    case dashboardProposalTypes.DASHBOARD_PROPOSAL_EXPORT_FAILURE:
      return {
        ...state,
        dashboardExportResponse: action.payload,
      };

    case dashboardProposalTypes.DASHBOARD_PROPOSAL_EXPORT_CHANGED:
      return { ...state, dashboardExportResponse: null };

    default:
      return state;
  }
};

export default DashboardReducer;
